<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        class="admin-add-btn"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Adicionar aprovador
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-shield-account</v-icon>
        <div>
          <span class="sc-modal__title">Adicionar aprovador</span>
          <span class="sc-modal__subtitle">Insira o login de rede do novo aprovador</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Login de rede</label>
          <v-text-field
            v-model="dsc_login_aprovador_perfil"
            placeholder="Ex: nome.sobrenome"
            solo
            flat
            dense
            hide-details="auto"
            background-color="surface_tertiary"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="dialog = false" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="inserirAprovador"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
export default {
  name: "ModalInserirAprovador",
  props: {
    perfil: Number,
    fetchData: Function,
  },
  data() {
    return {
      dialog: false,
      dsc_login_aprovador_perfil: "",
      loading: false,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.dsc_login_aprovador_perfil = "";
    },
  },
  methods: {
    async inserirAprovador() {
      try {
        if (this.dsc_login_aprovador_perfil.trim() === "") {
          return this.$toast.error("Preencha o campo login do aprovador.");
        }

        this.loading = true;
        const response = await apiClient.post("/inserirAprovadorPerfilSocialCam", {
          dsc_login_aprovador_perfil: this.dsc_login_aprovador_perfil,
          cod_perfil: this.perfil,
        });

        if (response.status === 200) {
          this.$toast.success("Login aprovador inserido com sucesso.");
          this.dsc_login_aprovador_perfil = "";
          await this.fetchData();
        }
      } catch (error) {
        this.$toast.error("Erro ao inserir aprovador.");
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
  },
};
</script>
